import { Box, Typography, Container, Link, Divider } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";
import PhoneIcon from "@mui/icons-material/Phone";
import RSVPButton from "../components/RSVPButton";

function RSVP() {
  const titleRef = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const buttonRef = useRef(null);
  const contactsRef = useRef(null);
  const dividerRef = useRef(null);

  const titleInView = useInView(titleRef, { once: true, margin: "0px" });
  const isInView1 = useInView(ref1, { once: true, margin: "0px" });
  const isInView2 = useInView(ref2, { once: true, margin: "0px" });
  const isInView3 = useInView(ref3, { once: true, margin: "0px" });
  const buttonInView = useInView(buttonRef, { once: true, margin: "0px" });
  const contactsInView = useInView(contactsRef, { once: true, margin: "0px" });
  const dividerInView = useInView(dividerRef, { once: true, margin: "0px" });
  const { animationStarted } = useAnimation();

  return (
    <section
      id="rsvp"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        scrollMarginTop: "20px",
      }}
    >
      <Container maxWidth="md" sx={{ mt: 6 }}>
        <Box
          sx={{
            textAlign: "center",
            px: { xs: 2, sm: 4, md: 6 },
          }}
        >
          {/* Title */}
          <Typography
            component={motion.h1}
            ref={titleRef}
            initial={{ opacity: 0, y: 40 }}
            animate={titleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            variant="h1"
            sx={{
              fontFamily: '"Playfair Display", Georgia, serif',
              fontSize: { xs: "2.5rem", sm: "3.5rem" },
              fontWeight: 400,
              color: "#1a3a52",
              letterSpacing: "1px",
              mb: 6,
              textAlign: "center",
            }}
          >
            Confirmar Presença
          </Typography>

          {/* Main Text - First Paragraph */}
          <Typography
            component={motion.p}
            ref={ref1}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            variant="body1"
            align="justify"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 2,
              color: "#2d4e66",
              mb: 2,
            }}
          >
            Família e Amigos, se ainda não tiveram oportunidade de confirmar a
            vossa presença no nosso dia, confirmem, por favor, através do RSVP
            ou dos nossos contactos telefónicos até ao dia 4 de maio de 2026.
          </Typography>

          {/* Main Text - Second Paragraph */}
          <Typography
            component={motion.p}
            ref={ref2}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            variant="body1"
            align="justify"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 2,
              color: "#2d4e66",
              mb: 2,
            }}
          >
            Confirmar a vossa presença vai ajudar-nos a planear cada detalhe
            deste dia e, em especial, guardar o vosso lugar na pista de dança!
          </Typography>

          {/* Main Text - Third Paragraph */}
          <Typography
            component={motion.p}
            ref={ref3}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView3 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            variant="body1"
            align="justify"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 2,
              color: "#2d4e66",
              mb: 4,
            }}
          >
            Muito obrigado e vemo-nos dia 4 de julho!
          </Typography>

          {/* RSVP Button */}
          <Box
            component={motion.div}
            ref={buttonRef}
            initial={{ opacity: 0, y: 20 }}
            animate={
              buttonInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
            }
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            sx={{ mb: 4, display: "flex", justifyContent: "center" }}
          >
            <RSVPButton mt={0} />
          </Box>

          {/* Contacts Section */}
          <Box
            component={motion.div}
            ref={contactsRef}
            initial={{ opacity: 0, y: 30 }}
            animate={
              contactsInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }
            }
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            sx={{
              mt: 6,
              pt: 0,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "0.9rem", sm: "1rem" },
                fontWeight: 600,
                color: "#1a3a52",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                mb: 2,
              }}
            >
              Contactos
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "center",
                alignItems: "center",
                gap: { xs: 2, sm: 4 },
              }}
            >
              {/* Isabela Contact */}
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  sx={{
                    fontFamily: '"Open Sans", sans-serif',
                    fontSize: { xs: "1rem", sm: "1.05rem" },
                    fontWeight: 500,
                    color: "#1a3a52",
                    mb: 0.5,
                  }}
                >
                  Isabela
                </Typography>
                <Link
                  href="tel:+351918362647"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    textDecoration: "none",
                    color: "#1a3a52",
                    justifyContent: "center",
                    "&:hover": {
                      color: "#2d4e66",
                    },
                  }}
                >
                  <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
                  <Typography
                    sx={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: { xs: "0.95rem", sm: "1rem" },
                      fontWeight: 300,
                    }}
                  >
                    +351 918 362 647
                  </Typography>
                </Link>
              </Box>

              {/* Tiago Contact */}
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  sx={{
                    fontFamily: '"Open Sans", sans-serif',
                    fontSize: { xs: "1rem", sm: "1.05rem" },
                    fontWeight: 500,
                    color: "#1a3a52",
                    mb: 0.5,
                  }}
                >
                  Tiago
                </Typography>
                <Link
                  href="tel:+351914287652"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    textDecoration: "none",
                    color: "#1a3a52",
                    justifyContent: "center",
                    "&:hover": {
                      color: "#2d4e66",
                    },
                  }}
                >
                  <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
                  <Typography
                    sx={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: { xs: "0.95rem", sm: "1rem" },
                      fontWeight: 300,
                    }}
                  >
                    +351 914 287 652
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </section>
  );
}

export default RSVP;
